import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Button } from '@3plearning/react-components';
import classNames from 'classnames';
import _ from 'lodash';
import { PreviewDemoIcon } from '../../helpers/icon-dictionary';
import { LearningJourneyRowWrapper, Info } from './styled';
import Checkbox from '../checkbox';
import ContextModal from '../context-modal';
import { getUpfPreview } from '../../containers/link-upf-modal/link-upf-modal-actions';
import { getQuestion, getDomainFromStrand } from '../../containers/link-upf-modal/link-upf-modal-utils';
import InfoRow from './info-row';
import { showToast } from '../toast/toast-action';
import QuestionDomain from '../top-problem-questions/question-domain';

const LearningJourneyRow = ({ i18n, onCheckboxChange, learningJourney, questions, showStudentLJ }) => {
  const dispatch = useDispatch();
  let contextModalWidth = 270;
  let infoHeader = i18n.t`Percentage of Incorrect Responses`;
  if (showStudentLJ) {
    contextModalWidth = 170;
    infoHeader = i18n.t`Incorrect Responses`;
  }
  const { genericCourses } = useSelector(state => state.UPFAssignReducer);
  const selectedProduct = useSelector(state => state.product, shallowEqual);
  const [isPreviewDisabled, setIsPreviewDisabled] = useState(false);
  const infoRef = useRef(null);
  const [showCallOutMenu, setCallOutMenu] = useState(false);
  const [positionXCallout, setPositionXCallout] = useState(0);
  const [positionArrowCallout, setPositionArrowCallout] = useState(0);

  const handlePreview = async () => {
    setIsPreviewDisabled(true);
    const { courseId, courseVersion, id } = learningJourney;
    const url = await getUpfPreview({
      productId: selectedProduct && selectedProduct.id,
      courseId,
      courseVersion,
      learningJourneyId: id
    });
    if (url) {
      open(url, '_blank');
      setIsPreviewDisabled(false);
    } else {
      dispatch(
        showToast(
          i18n.t`Preview unavailable for this activity, please choose another.`,
          'warning'
        )
      );
    }
  };

  const showCallOut = (e) => {
    const { left, right } = infoRef.current.getBoundingClientRect();
    const x = Math.min((right - contextModalWidth) + 20, e.clientX - (contextModalWidth / 2));
    setPositionXCallout(x - left);
    setPositionArrowCallout(e.clientX - x);
    setCallOutMenu(true);
  };

  const hideCallOut = () => {
    setCallOutMenu(false);
  };

  return (
    <LearningJourneyRowWrapper showStudentLJ={showStudentLJ}>
      <Checkbox
        checkboxHandler={onCheckboxChange}
        state={learningJourney.checkboxState}
        id={learningJourney.index}
      />
      <span title={learningJourney.name}>{learningJourney.name}</span>
      <QuestionDomain domainName={getDomainFromStrand(learningJourney.strandCode)} />
      <Button
        className={classNames('button', 'preview-button')}
        primary
        text={i18n.t`Preview`}
        type={Button.LOZENGE}
        onClick={handlePreview}
        alignIcon="LEFT"
        icon={PreviewDemoIcon}
        disabled={isPreviewDisabled}
      />
      <u
        onMouseEnter={showCallOut}
        onMouseLeave={hideCallOut}
        ref={infoRef}
      >
        {i18n.t`Why assign this?`}
        <ContextModal
          show={showCallOutMenu}
          positionArrow={positionArrowCallout}
          positionX={positionXCallout}
          positionY={20}
          modalWidth={contextModalWidth}
        >
          <Info>
            <span className="heading"><b>{infoHeader}</b></span>
            {learningJourney.relatedQuestions.map((girlId) => {
              const { name, domain } = getQuestion(girlId, genericCourses);
              return (<InfoRow
                i18n={i18n}
                key={girlId}
                question={name}
                topic={domain}
                percentage={_.get(questions.find(q => q.girlId === girlId), 'pct')}
                showStudentLJ={showStudentLJ}
              />);
            })}
          </Info>
        </ContextModal>
      </u>
    </LearningJourneyRowWrapper>
  );
};

LearningJourneyRow.propTypes = {
  i18n: PropTypes.object,
  onCheckboxChange: PropTypes.func.isRequired,
  learningJourney: PropTypes.object,
  questions: PropTypes.array,
  showStudentLJ: PropTypes.bool
};

export default LearningJourneyRow;
